var _rect, _rect2, _g, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33337,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_193_10233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 21,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9994,
    y: 11,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_193_10233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0828 27.6663C15.3825 27.6663 14.7873 27.4253 14.2972 26.9433C13.807 26.4612 13.5619 25.8758 13.5619 25.1872C12.9925 25.1872 12.5619 25.0158 12.2703 24.6731C11.9786 24.3304 11.8328 23.9184 11.8328 23.4372V16.083C11.8328 15.6018 12.0041 15.1898 12.3468 14.8471C12.6895 14.5044 13.1015 14.333 13.5828 14.333H23.4578C23.939 14.333 24.351 14.5044 24.6937 14.8471C25.0364 15.1898 25.2078 15.6018 25.2078 16.083V17.6663H27.31C27.4502 17.6663 27.5828 17.6976 27.7078 17.7601C27.8328 17.8226 27.935 17.9067 28.0146 18.0125L30.0032 20.6505C30.0563 20.7166 30.0967 20.7935 30.1244 20.8813C30.1522 20.969 30.1661 21.064 30.1661 21.1663V24.3035C30.1661 24.5454 30.0793 24.7531 29.9057 24.9268C29.7321 25.1004 29.5272 25.1872 29.2911 25.1872H28.4994C28.4994 25.8816 28.2543 26.4684 27.7642 26.9476C27.274 27.4268 26.6788 27.6663 25.9786 27.6663C25.2784 27.6663 24.6832 27.4253 24.193 26.9433C23.7028 26.4612 23.4578 25.8758 23.4578 25.1872H18.6036C18.6036 25.8816 18.3585 26.4684 17.8683 26.9476C17.3782 27.4268 16.783 27.6663 16.0828 27.6663ZM16.0828 25.9163C16.2911 25.9163 16.4717 25.84 16.6244 25.6872C16.7772 25.5344 16.8536 25.3538 16.8536 25.1455C16.8536 24.9372 16.7772 24.7566 16.6244 24.6038C16.4717 24.4511 16.2911 24.3747 16.0828 24.3747C15.8744 24.3747 15.6939 24.4511 15.5411 24.6038C15.3883 24.7566 15.3119 24.9372 15.3119 25.1455C15.3119 25.3538 15.3883 25.5344 15.5411 25.6872C15.6939 25.84 15.8744 25.9163 16.0828 25.9163ZM25.9786 25.9163C26.1869 25.9163 26.3675 25.84 26.5203 25.6872C26.673 25.5344 26.7494 25.3538 26.7494 25.1455C26.7494 24.9372 26.673 24.7566 26.5203 24.6038C26.3675 24.4511 26.1869 24.3747 25.9786 24.3747C25.7703 24.3747 25.5897 24.4511 25.4369 24.6038C25.2842 24.7566 25.2078 24.9372 25.2078 25.1455C25.2078 25.3538 25.2842 25.5344 25.4369 25.6872C25.5897 25.84 25.7703 25.9163 25.9786 25.9163ZM25.2078 21.7913H28.6453L26.8744 19.4163H25.2078V21.7913Z",
    fill: "#AAABB2"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.33337,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#E1E1E5",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.85d7b1ccf013a0ca25628b9dd599c2ee.svg";
export { ForwardRef as ReactComponent };